export default __webpack_public_path__ + "static/media/mysterium.73e3faa9.jpg";